import { request } from './HttpBridge'
import { HttpMethod } from './types'

export interface ApiResponse<T = unknown> {
  /** 原生返回状态码，200表示成功，非200表示失败 */
  code: number
  /** 响应数据 */
  data?: T
  /** 错误信息 */
  msg?: string
}

/**
 * 发送GET请求
 * @param url 请求URL
 * @returns Promise<T> 响应数据
 */
export function get<T = unknown>(url: string) {
  return request<ApiResponse<T>>({
    url,
    method: HttpMethod.GET,
  })
}

/**
 * 发送POST请求
 * @param url 请求URL
 * @param data 请求数据
 * @returns Promise<T> 响应数据
 */
export function post<T = unknown>(url: string, data?: unknown) {
  return request<T>({
    url,
    method: HttpMethod.POST,
    data,
  })
}

const nativeHttp = {
  request,
  get,
  post,
}

export default nativeHttp
